import React from "react";

const Reservation = () => {
  return <h1>Reservation Page</h1>;
};

export default Reservation;